import { PropsWithChildren, ReactElement } from "react";
import AgentReportProvider from "./AgentReportContext.Provider";
import QueueReportsProvider from "./QueueReportsContext.Provider";
import SignalRConnectionProvider from "./SignalRConnectionContext.Provider";
import TeamReportsProvider from "./TeamReportsContext.Provider";
import WaitingConversationsProvider from "./WaitingConversationsContext.Provider";
import WebsiteVisitorsProvider from "./WebsiteVisitorsContext.Provider";

/**
 * Contains all necessary providers for accessing the reporting data.
 *
 * **Provider dependencies:**
 * - (Store) Provider
 */
export default function ReportingDataProviders({ children }: PropsWithChildren): ReactElement {
  return (
    <SignalRConnectionProvider>
      <QueueReportsProvider>
        <WaitingConversationsProvider>
          <TeamReportsProvider>
            <AgentReportProvider>
              <WebsiteVisitorsProvider>
                {children}
              </WebsiteVisitorsProvider>
            </AgentReportProvider>
          </TeamReportsProvider>
        </WaitingConversationsProvider>
      </QueueReportsProvider>
    </SignalRConnectionProvider>
  );
}
